import React from 'react'
import { TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export default function TablaCumplimientoDeCuposNominables () {
  return (
    <MuiTable id={TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES} />
  )
}
